__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/60d0108/packs/";